import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a30bb0f2&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=a30bb0f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_l4g5nlw2jejcj23wpoomwoyaia/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30bb0f2",
  null
  
)

export default component.exports